<ng-container *transloco="let t">
    <app-page-template [showFooter]="false" [slateBackground]="true">

        <app-my-tracey-page-header [key]="'app.common.back'" (onBackCallback)="goBack()">

        </app-my-tracey-page-header>

        <div class="container pt-20-10 pb-300-100">
            <div class="d-flex flex-column justify-content-start gap-4">
                <p class="fs-20 fw-semibold">{{ t('app.register.to.race.confirmation.payment.options') }}</p>
                <p *ngIf="!isMobile" class="color-slate-600">{{ t('my.entry.payment.options.choose') }}</p>

                <div *ngIf="registration?.wsPayFormUrl?.length" class="section border d-flex flex-column gap-3 w-md-60">

                    <div class="d-flex align-items-center justify-content-start gap-2">
                        <div class="section grey">
                            <img src="assets/icons/icons-alt/card-icon.svg" alt="Card" style="justify-self: center; height: 20px; width: 20px;">
                        </div>
                        <p class="fs-16 fw-600">{{ t('app.common.paymentType.1')}}</p>
                    </div>

                    <p class="fs-14 color-slate-600">{{ t('my.entry.payment.online.ws.pay') }}</p>

                    <app-button-alt
                            [text]="t('app.register.to.race.proceed.to.payment') | uppercase"
                            [buttonHeight]="'44px'"
                            (onClickCallback)="payWithCard()">
                    </app-button-alt>
                </div>

                <div class="section border d-flex flex-column w-md-60 gap-md-3">
                  <div class="d-flex align-items-center justify-content-between d-md-block">
                        <div class="d-flex align-items-center justify-content-start gap-2">
                            <div class="section grey">
                                <img src="assets/icons/icons-alt/bank-icon.svg" alt="Bank"  style="justify-self: center; height: 20px; width: 20px;">
                            </div>
                            <p class="fs-16 fw-600">{{ t('app.common.paymentType.2') }}</p>
                        </div>

                        <div *ngIf="isMobile" (click)="toggleDropdown()" class="cursor-pointer">
                            <i class="bi fs-18 chevron-icon"
                               [class.rotated]="dropdownOpened"
                               [ngClass]="'bi-chevron-down'"></i>
                        </div>

                    </div>
                    <p *ngIf="!dropdownOpened || !isMobile" class="fs-14 color-slate-600 mt-3 mt-md-0">
                        {{ t('my.entry.payment.bank.transfer') }}
                    </p>
                    <div class="d-flex flex-column gap-2">
                        @if (registration && registration.bankTransferInfo) {
                        @if (!isMobile) {
                        <ng-template [ngTemplateOutlet]="iban"></ng-template>
                        <div class="d-grid align-items-start mt-3"
                             [style.grid-template-columns]="'repeat(2, 1fr)'"
                             [style.gap]="'1rem'">
                            <ng-template [ngTemplateOutlet]="payee"></ng-template>
                            <ng-template [ngTemplateOutlet]="modelAndReferenceNumber"></ng-template>
                            <ng-template [ngTemplateOutlet]="amountAndCurrency"></ng-template>
                            <ng-template [ngTemplateOutlet]="endDateForPayment"></ng-template>
                        </div>
                        <ng-template [ngTemplateOutlet]="barcode"></ng-template>
                        } @else {
                        @if (dropdownOpened) {
                        <div class="divider-horizontal margin-16"></div>
                        <div class="d-grid align-items-start"
                             [style.grid-template-columns]="'1fr'"
                             [style.gap]="'1rem'">
                          <ng-template [ngTemplateOutlet]="amountAndCurrency"></ng-template>
                          <ng-template [ngTemplateOutlet]="payee"></ng-template>
                          <ng-template [ngTemplateOutlet]="iban"></ng-template>
                          <ng-template [ngTemplateOutlet]="modelAndReferenceNumber"></ng-template>
                          <ng-template [ngTemplateOutlet]="endDateForPayment"></ng-template>
                        </div>
                        <ng-template [ngTemplateOutlet]="barcode"></ng-template>
                        }
                        }




                        <ng-template #iban>
                          <div class="d-flex justify-content-between align-items-center d-md-block">
                            <p class="color-slate-600"> {{ t('organiser.payment.data.iban') }} </p>
                              <div class="section-desktop grey-50 d-md-flex justify-content-between align-items-center">
                                  <p>
                                    {{ registration.bankTransferInfo.barcodePaymentDTO?.payeeIban }}
                                  </p>
                                  <img *ngIf="!isMobile" src="assets/icons/icons-alt/copy.svg" alt="Copy"
                                    class="card-body__icon cursor-pointer" style="justify-self: center; height: 20px; width: 20px;"
                                    (click)="copyIban(registration.bankTransferInfo.barcodePaymentDTO?.payeeIban)">
                                </div>
                            </div>
                        </ng-template>
                  <ng-template #modelAndReferenceNumber>
                    <div class="d-flex justify-content-between align-items-center d-md-block">
                      <p class="color-slate-600">{{ t('app.payment.information.model.and.reference') }}</p>
                <p>{{ registration.bankTransferInfo.barcodePaymentDTO?.payeeModel }}
                        {{ registration.bankTransferInfo.barcodePaymentDTO?.payeeReferenceNumber }}</p>
              </div>
            </ng-template>
            <ng-template #amountAndCurrency>
              <div class="d-flex justify-content-between align-items-center d-md-block">
                <p class="color-slate-600">{{ t('app.register.to.race.price') }}</p>
                <p>{{ registration.bankTransferInfo.barcodePaymentDTO?.amount }}
                        {{ registration.bankTransferInfo.barcodePaymentDTO?.currencyCode }}</p>
              </div>
            </ng-template>
            <ng-template #endDateForPayment>
              @if (registration?.endDateForPayment) {
                        <div class="d-flex justify-content-between align-items-center d-md-block">
                            <p class="color-slate-600">{{ t('my.entry.payment.deadline') }}</p>
                            <app-event-date-display [start]="registration?.endDateForPayment"/>
                        </div>
                        }
                        </ng-template>
                        <ng-template #payee>
                          <div class="d-flex justify-content-between align-items-center d-md-block">
                            <p class="color-slate-600">{{ t('app.payment.information.payee') }}</p>
                <p>{{ registration.bankTransferInfo.barcodePaymentDTO?.payee?.name }}</p>
              </div>
            </ng-template>
            <ng-template #barcode>
              @if (registration.bankTransferInfo?.barcode) {
                        <div class="section grey-50 d-flex flex-column gap-2 mt-2">
                            <img
                                    class="img-fluid"
                                    [src]="'data:image/png;base64,' + registration.bankTransferInfo.barcode"
                                    alt="barcode">
                            <div class="d-flex justify-content-center">
                                <p class="color-slate-600">
                                    {{ t('app.register.to.race.confirmation.use.code.for.online.banking') }}
                                </p>
                            </div>

                        </div>
                        }
                        </ng-template>
                        <ng-template #bankDropdown>

                          <div class="dropdown-wrapper mb-3">
                            <div class="section d-flex justify-content-between align-items-center p-3 cursor-pointer border-light-gray"
                                 (click)="toggleDropdown()"
                                 style="background-color: var(--teal-50); border-radius: 8px;"
                                 [style.border-bottom-radius]="dropdownOpened ? '0' : '8px'">

                              <div class="d-flex align-items-center gap-3">
                                <div class="icon-box p-2 bg-white rounded border">
                                  <img src="assets/icons/icons-alt/bank-icon.svg" alt="Bank"  style="justify-self: center; height: 20px; width: 20px;">
                                </div>
                                <div>
                                  <p class="m-0 fw-bold">{{ t('app.common.paymentType.2') }}</p>
                      <p class="m-0 color-slate-600 fs-14">{{ t('my.entry.payment.bank.transfer') }}</p>
                    </div>
                  </div>

                  <i class="bi bi-chevron-down transition-all" [style.transform]="dropdownOpened ? 'rotate(180deg)' : 'none'"></i>
                </div>


              </div>
            </ng-template>
                        }
                    </div>
                </div>

                <div class="d-flex justify-content-start align-items-center section blue color-slate-600 w-md-60">
                    <img src="assets/icons/icons-alt/warning-icon.svg" alt="Info" class="card-body__icon pe-2"/>
                    <p class="fs-14 color-slate-600"> {{ t('my.entry.payment.info.registration') }} </p>
                </div>
            </div>

        </div>


    </app-page-template>

</ng-container>
